<template>
	<el-dialog :modal-append-to-body="false" class="transform-dialog" :title="title" 
		:visible.sync="transformViews.show" :append-to-body="true"
		:close-on-click-modal="false" :show-close="false" width="680px">
		<table-pagination
			ref="tableItem"
			:data="list"
			@selection-change="handleSelectionChange"
			:column="column"/>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" @click="onCancel" :loading="refuse_loading">{{refuse_loading ? '提交中...' : '拒 绝'}}</el-button>
			<el-button size="small" type="primary" @click="onSubmit" :accept_loading="accept_loading">{{accept_loading ? '提交中...' : '确 定'}}</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import { mapState } from 'vuex';
	import { uniqueArray } from '@/utils/imService'
	export default {
		computed:{
			...mapState({
				transformViews:state => state.imChatService.transformViews
			}),
			list(){
				return uniqueArray(this.transformViews.list,'session_id')
			}
		},
		data() {
			return {
				title: '转接请求',
				column:[
					{ label: '序号', prop: 'index', type: 'index',width:60 },
					{ label: '选择', prop: 'selection', type: 'selection',width:50,algin:'center' },
					{label:'会话ID',prop:'session_id'},
					{label:'转接人',prop:'name'},
					{label:'转接人所属技能组',prop:'skillGroupName'}
				],
				selects:[],
				accept_loading:false,
				refuse_loading:false
			}
		},
		methods: {
			// 拒绝
			onCancel() {
				if(this.selects.length == 0) return this.$message.warning('请选择您要拒绝的会话');
				let index = 0;
				this.refuse_loading = true;
				let total = JSON.parse(JSON.stringify(this.selects.length));
				this.selects.map(item => {
					this.$api.refusedTransformImService(item,this.$store.state.user.agentId)
					  .then(res => {
						  this.refuse_loading = false;
						  if(res.errcode != 0) return;
						  index = index + 1;
						  this.$store.commit('imChatService/UPDATE_TRANSFORM_VIEW',{
							  list:this.deleteLists(item.session_id)
						  })
						  if(index == total){
							  this.$message.success("已成功拒绝转接请求");
							  console.log('进来了')
							  this.$store.commit('imChatService/UPDATE_TRANSFORM_VIEW',{
								  show:false,
								  list:[]
							  })
							  
						  }
							
					  })
				})
			},
			// 接受
			onSubmit() {
			    if(this.selects.length == 0) return this.$message.warning('请选择您要接受的会话');
				this.accept_loading = true;
				let index = 0;
				let total = JSON.parse(JSON.stringify(this.selects.length));
				this.selects.map(item => {
					this.$api.acceptTransformImService(item,this.$store.state.user.agentId)
					  .then(res => {
						  this.accept_loading = false;
						  if(res.errcode != 0) return;
						  index = index + 1;
						  this.$store.commit('imChatService/UPDATE_TRANSFORM_VIEW',{
							  list:this.deleteLists(item.session_id)
						  })
						  if(index == total){
							  this.$message.success('已接受转接请求，请等待进线');
							  this.$store.commit('imChatService/UPDATE_TRANSFORM_VIEW',{
								  show:false,
								  list:[]
							  })
						 			 
						  }
					  })
				})
				
			},
			deleteLists(id){
				let results = JSON.parse(JSON.stringify(this.list));
				for(let i =0 ; i < results.length; i++){
					if(results[i].session_id == id){
						results.splice(i, 1);
						break;
					}
				}
				return results;
			},
			handleSelectionChange(rows){
				this.selects = rows
			},
		}
		 
	}
</script>

<style lang="scss">
	.transform-dialog {
		.el-table th.el-table__cell>.cell{
			padding: 0 14px;
		}
	}
</style>
